// tempexp_18086-start
import { logger } from 'lib/logger';
import { BillingReferralLinkAPICall } from 'reactApp/api/billing/referral/link/BillingReferralLinkAPICall';
import { emitAnalyticEvent } from 'reactApp/appHelpers/experimentAnalytic';
import { AnalyticEventNames } from 'reactApp/appHelpers/experimentAnalytic/eventNames';
import { REFERRAL_BUY_CODE, REFERRAL_STORED_API_ID } from 'reactApp/appHelpers/featuresHelpers/features/referralProgram';
import { getQueryParams } from 'reactApp/appHelpers/settingsHelpers';
import { PaymentUTM } from 'reactApp/constants/paymentUTM';
import { loadPaidInfoRequest } from 'reactApp/modules/paidInfo/paidInfo.module';
import { handlePaidInfoSuccess } from 'reactApp/modules/paidInfo/paidInfo.saga';
import { PaidInfoSelectors } from 'reactApp/modules/paidInfo/paidInfo.selectors';
import { initProductsForAnonymous } from 'reactApp/modules/products/products.module';
import { storeHelper } from 'reactApp/modules/promo/promo.helpers';
import { ReferralProgramActions } from 'reactApp/modules/referralProgram/referralProgram.module';
import { UserSelectors } from 'reactApp/modules/user/user.selectors';
import { getQuotaPromoUrl } from 'reactApp/sections/QuotaLanding/QuotaLanding.data';
import { renderReferralDisabledModal } from 'reactApp/ui/ReferralProgram/ReferralDisabledModal/ReferralDisabledModal.helpers';
import { ETabsName } from 'reactApp/ui/TariffSectionNew/TariffSection.constants';
import { sendXray } from 'reactApp/utils/ga';
import { ECategoryGa, sendPaymentGa } from 'reactApp/utils/paymentGa';
import { captureException } from 'reactApp/utils/tracer';
import { takeLeading } from 'redux-saga/effects';
import { call, cancel, put, select } from 'typed-redux-saga';

import { ReferralProgramSelectors } from './referralProgram.selectors';

const callReferralLinkApi = () => {
    return new BillingReferralLinkAPICall().makeRequest();
};
function* handleGetReferralLinkRequest() {
    const link = yield* select(ReferralProgramSelectors.getLink);
    if (link) {
        yield put(ReferralProgramActions.getReferralLinkSuccess(link));
        yield cancel();
    }
    try {
        sendXray(['referralLink', 'request']);
        const {
            data: { code: ref_id },
        } = yield* call(callReferralLinkApi);
        storeHelper.setValue(REFERRAL_STORED_API_ID, ref_id);
        sendXray(['referralLink', 'request', 'success']);
        const link = getQuotaPromoUrl({
            query: `ref_id=${ref_id}&tab=${ETabsName.month}&${PaymentUTM.referralProgram}`,
        });
        yield put(ReferralProgramActions.getReferralLinkSuccess(link));
    } catch (error) {
        sendXray(['referralLink', 'request', 'error']);
        logger.error(error);
        captureException(error, { issueKey: `referralLink/error` });
        yield put(ReferralProgramActions.getReferralLinkFailure());
        yield cancel();
    }
}

function* handleStartPromoQuotaReferral() {
    const queryParams = getQueryParams();
    if (queryParams.ref_id) {
        const storedRefIdFromApi = storeHelper.getValue(REFERRAL_STORED_API_ID);
        // Проверяем что реферальная ссылка, по которой открыли лендинг не совпадает с собственной реферальной ссылкой
        // то есть, что мы не даем бонус сами себе
        if (storedRefIdFromApi === queryParams.ref_id) {
            yield cancel();
        }

        const isAnonymous = yield select(UserSelectors.isAnonymous);
        if (isAnonymous) {
            yield put(initProductsForAnonymous());
        } else {
            yield put(loadPaidInfoRequest());
            yield handlePaidInfoSuccess();
        }
        const isPaidUser = yield* select(UserSelectors.isPaidUser);
        const isSocialUser = yield* select(UserSelectors.isSocialUser);
        const isBizUser = yield* select(UserSelectors.isBizUser);
        const isUserWithoutPayment = yield* select(PaidInfoSelectors.isUserWithoutPayment);
        if (isAnonymous || (!isPaidUser && !isSocialUser && !isBizUser && isUserWithoutPayment)) {
            storeHelper.setValue(REFERRAL_BUY_CODE, queryParams.ref_id);
            yield put(ReferralProgramActions.setRefId(queryParams.ref_id));
        } else {
            const name = 'cannot_have_referal_discount';
            yield renderReferralDisabledModal({
                onShow() {
                    emitAnalyticEvent(AnalyticEventNames.REFERRAL_FAILED_MODAL_SHOW);
                    sendPaymentGa({
                        action: 'show',
                        eventCategory: ECategoryGa.modal,
                        name,
                    });
                },
                onClose() {
                    emitAnalyticEvent(AnalyticEventNames.REFERRAL_FAILED_MODAL_CLOSE);
                    sendPaymentGa({
                        action: 'close',
                        eventCategory: ECategoryGa.modal,
                        name,
                    });
                },
                onClick() {
                    emitAnalyticEvent(AnalyticEventNames.REFERRAL_FAILED_MODAL_CLICK);
                    sendPaymentGa({
                        action: 'click',
                        eventCategory: ECategoryGa.modal,
                        name,
                    });
                },
            });
        }
    }
}

export function* watchReferralProgram() {
    yield takeLeading(ReferralProgramActions.getReferralLinkRequest, handleGetReferralLinkRequest);
    yield takeLeading(ReferralProgramActions.startPromoQuotaReferral, handleStartPromoQuotaReferral);
}
// tempexp_18086-end
